var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewNextChargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.396484,
    width: 69.5197,
    height: 69.5197,
    rx: 5,
    fill: "#EDF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6758 28.5352C22.6758 26.326 24.4666 24.5352 26.6758 24.5352H42.6758C44.8849 24.5352 46.6758 26.326 46.6758 28.5352V32.5352H22.6758V28.5352Z",
    fill: "#9EB5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6758 32.5339H46.6758M29.3424 27.2005V21.8672M40.0091 27.2005V21.8672M31.2091 48.5339H38.1424C41.1294 48.5339 42.6229 48.5339 43.7637 47.9526C44.7673 47.4412 45.5832 46.6253 46.0945 45.6218C46.6758 44.4809 46.6758 42.9875 46.6758 40.0005V33.0672C46.6758 30.0802 46.6758 28.5868 46.0945 27.4459C45.5832 26.4424 44.7673 25.6265 43.7637 25.1152C42.6229 24.5339 41.1294 24.5339 38.1424 24.5339H31.2091C28.2222 24.5339 26.7287 24.5339 25.5878 25.1152C24.5843 25.6265 23.7684 26.4424 23.2571 27.4459C22.6758 28.5868 22.6758 30.0802 22.6758 33.0672V40.0005C22.6758 42.9875 22.6758 44.4809 23.2571 45.6218C23.7684 46.6253 24.5843 47.4412 25.5878 47.9526C26.7287 48.5339 28.2222 48.5339 31.2091 48.5339Z",
    stroke: "#2828F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNextChargeIcon);
export default __webpack_public_path__ + "static/media/newNextChargeIcon.a4a31124c6edc8996ac6e007813890e6.svg";
export { ForwardRef as ReactComponent };